// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__fn6mb","actions":"LoginForm_actions__z73aq","btn":"LoginForm_btn__3OjPC"};